import React from 'react';
import { createTemplate } from '@/helpers/createTemplate';
import template from './template/template';

export default function ErrorBoundary() {
  return <>{createTemplate(template)}</>;
}
